import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLogoKoodous = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinejoin: "round",
		strokeMiterlimit: 2
	},
	viewBox: "0 0 31 31",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M58.215 0C26.279 0 0 26.279 0 58.214v.001c.001 31.935 26.279 58.213 58.214 58.213h.001a58.22 58.22 0 0 0 40.654-16.613l-31.93-33.348-30.553 32.104V18.36l30.531 31.889 32.01-33.635A58.22 58.22 0 0 0 58.214.001zm47.965 25.238L74.668 58.345l31.459 32.861a58.2 58.2 0 0 0 10.301-32.992 58.2 58.2 0 0 0-10.248-32.977zm-58.596 21.01v24.314l11.605-12.193z",
		style: { fillRule: "nonzero" },
		transform: "scale(.26458)"
	})
});
export default SvgLogoKoodous;
